/* eslint-disable max-len */
import colors from './colors.js'

/* methods used in multiple components */

const Helpers = {
  async fetchPostJson(url, data, headers = {}) {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    const headerKeys = Object.keys(headers)
    if (headerKeys?.length > 0) {
      headerKeys.forEach((key) => {
        myHeaders.append(key, headers[key])
      })
    }
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(data),
      redirect: 'follow',
    }

    const response = await fetch(url, requestOptions)
    // parses JSON response into native JavaScript objects
    return response.json()
  },

  async fetchPostJson3(url, headers, data) {
    const myHeaders = new Headers(headers)
    myHeaders.append('Content-Type', 'application/json')

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(data),
      redirect: 'follow',
      connection: 'keep-alive',
    }

    const response = await fetch(url, requestOptions)
    // parses JSON response into native JavaScript objects
    return response.json();
  },

  async fetchPostJson2(url, data, headers = {}) {
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    const headerKeys = Object.keys(headers)
    if (headerKeys?.length > 0) {
      headerKeys.forEach((key) => {
        myHeaders.append(key, headers[key])
      })
    }
    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: JSON.stringify(data),
      redirect: 'follow',
    }

    const response = await fetch(url, requestOptions)
    // parses JSON response into native JavaScript objects
    return response
  },

  async fetchGet(url, headers) {
    const myHeaders = new Headers(headers)
    myHeaders.append('Content-Type', 'application/json')
    const requestOptions = {
      headers: myHeaders,
      redirect: 'follow',
    }

    const response = await fetch(url, requestOptions)
    // parses JSON response into native JavaScript objects
    return response.json()
  },

  time() {
    const now = new Date()
    const hour = now.getHours()
    const min = now.getMinutes()
    return `${hour}:${min}`
  },

  mysteryCaseToDisplay(str) {
    if (str) {
      if (str.includes('_')) {
        return this.snakeCaseToDisplay(str)
      } else {
        return this.camelCaseToDisplay(str)
      }
    }
  },

  camelCaseToDisplay(str) {
    const result = str.replace(/([A-Z])/g, ' $1')
    return result.charAt(0).toUpperCase() + result.slice(1)
  },

  snakeCaseToDisplay(str) {
    let result = str.charAt(0).toUpperCase() + str.slice(1)
    while (result.includes('_')) {
      const indexOfFirst_ = result.indexOf('_')
      result = result.slice(0, indexOfFirst_) + ' ' + result.charAt(indexOfFirst_ + 1).toUpperCase() + result.slice(indexOfFirst_ + 2)
    }
    return result
  },

  displayToSnakeCase(val) {
    return val.toLowerCase().replace(' ', '_')
  },

  copyToClipBoard(copyText, successCb = () => {}) {
    navigator.permissions.query({name: 'clipboard-write'})
        .then((result) => {
          if (result.state === 'granted' || result.state === 'prompt') {
            /* write to the clipboard */
            navigator.clipboard.writeText(copyText)
                .then(() => {
                  /* clipboard successfully set */
                  successCb()
                })
                .catch(clipboardCopyFallback)
          } else {
            clipboardCopyFallback()
          }
        })
        .catch(clipboardCopyFallback)

    function clipboardCopyFallback() {
      /*
        Necessary for Safari/Firefox or situtations without clipboard access:
        -Create invisible DOM element that contains copyText
        -Focus/select DOM element
        -copy content of DOM element
        -remove DOM element
      */
      const textArea = document.createElement('textarea')
      textArea.value = copyText

      // Avoid scrolling to bottom
      textArea.style.top = '0'
      textArea.style.left = '0'
      textArea.style.position = 'fixed'

      // create DOM element, focus, select DOM element
      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      // copy content of DOM element
      try {
        /*
          MDN says document.execCommand is deprecated
          but at the time of writing this (Feb 2023),
          it has wide browser support
        */
        document.execCommand('copy')
        successCb()
      } catch (err) {
        console.error('Unable to copy to clipboard: ', err)
      }
      // remove DOM element
      document.body.removeChild(textArea);
    }
  },

  timeStampToDate(timestamp) {
    if (timestamp) {
      const dateObj = new Date(timestamp)
      return (
        dateObj.getMonth() + 1 +
        '/' + dateObj.getDate() +
        '/' + dateObj.getFullYear()
      )
    }
  },

  timeStampToTime(timestamp) {
    const dateObj = new Date(timestamp)
    const hours = dateObj.getHours().toString()
    const minutes = dateObj.getMinutes().toString()
    const formattedHours = hours.length === 2 ? hours : '0' + hours
    const formattedMinutes = minutes.length === 2 ? minutes : '0' + minutes
    return (
      `${formattedHours}:${formattedMinutes}`
    )
  },

  formatDate(str) {
    if (str) {
      const dashB = str.slice(5, str.length) + '/' + str.slice(0, 4)
      return dashB.replace('-', '/')
    } else {
      return ''
    }
  },

  returnNewColor(i) {
    if (i >= colors.length) {
      return colors[i % colors.length]
    } else {
      return colors[i]
    }
  },

  returnIndexWithinRange(i, range) {
    if (i >= range) {
      return i % range
    } else {
      return i
    }
  },

  downloadJsonData(val, name) {
    const blob = new Blob([val], {type: 'application/json'});
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.setAttribute('href', url)
    a.setAttribute('download',
        (
        (name.substring(name.length - 5) === '.json') ?
          name :
          `${name}.json`
        ));
    a.click()
  },

  openLinkInNewTab(link) {
    Object.assign(document.createElement('a'), {
      target: '_blank',
      rel: 'noopener noreferrer',
      href: link,
    }).click();
  },

  truncateString(str, limit) {
    if (str?.length > limit) {
      return str.slice(0, limit) + '...'
    } else {
      return str
    }
  },

  assessSubSectionCompletion(subSectionData) {
    const ids = Object.keys(subSectionData)
    let completed = 0
    ids.forEach((id, i) => {
      const questionData = subSectionData[id]
      if (questionData.Answer) {
        completed++
      }
    })
    return {
      total: ids.length,
      completed,
    }
  },

  removeCheckbox(str) {
    if (str) {
      const boxChar = '□'
      const boxCharSpace = '□ '
      const step1 = str.replace(boxCharSpace, '')
      const step2 = step1.replace(boxChar, '')
      return step2
    }
  },

  getPercent(arr) {
    const x = arr[0]
    const total = arr[1]
    const decimalConfidence =
      isNaN(x / total) ?
          0 :
          (x / total)
    return (decimalConfidence * 100).toFixed(0)
  },
}

export default Helpers
